
import { ChangeDetectionStrategy, Component, forwardRef, ChangeDetectorRef, Input } from '@angular/core';
import { WizDropItemEvent, WIZ_DRAGGABLE_COMPONENT, WizDatasource } from '@wizeoo/akm-component-lib';
import { FIELD_KIND, EM_ACTION } from '@wizeoo/akm-compute-lib';

import { FormWidgetGridsterComponent } from '../../form/generic/form-widget.gridster.component';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { CompactType, GridType } from 'angular-gridster2';


@Component({
  selector: 'freedata-tile-gridster',
  template: `
  <div class ="wrapper" width="100%" height="100%" [style.background-color]="_backgroundColor" style="padding: 3px;">
    <gridster #gridster [options]="options" width="100%" height=100% class="gridster" tabindex="0" 
    [style.background-color]="_backgroundColor"
    [style.overflow]="overflow"
    >
      <gridster-item [item]="item" *ngFor="let item of widgets">
        <freedata-tile-gridster-item
          [provider]="provider"
          [model]="model"
          [field]="item"    
          [freedataValue]="freedataValue" 
          [templatingMode]="templatingMode"
          (delete)="onItemDeleted($event)"></freedata-tile-gridster-item>
      </gridster-item>
    </gridster>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: WIZ_DRAGGABLE_COMPONENT,
      useExisting: forwardRef(() => FreedataTileGridsterComponent),
    },
  ],
  styleUrls: ['../../form/generic/form-widget.gridster.component.scss']
})
export class FreedataTileGridsterComponent extends FormWidgetGridsterComponent {

  constructor(cdref: ChangeDetectorRef) {
    super(cdref);
  }


  _freeDataValueVO: FreedataValueVO;

  @Input() set freedataValue(fdv: FreedataValueVO) {
    this._freeDataValueVO = fdv;
  }
  get freedataValue(): FreedataValueVO {
    return this._freeDataValueVO;
  }

  @Input() provider: WizDatasource<any> = null;


  /**
   * @override pour mode de rendu hors template
   */
  public updateOptions() {
    super.updateOptions();
    this.options.gridType = this.templatingMode ? GridType.Fixed : GridType.Fit; //;
    this.options.compactType = CompactType.None;
  }

  onAddItemAfterDrag(pEvent: WizDropItemEvent): void {
    
    const item: GridsterWidgetItem = GridsterWidgetItem.constructFromGridster(this.gridster.emptyCell.getValidItemFromEvent(pEvent.event));
    item.field = pEvent.item.data as PivotField; 
    item.source = item.field.contextItem;
    item.updateCoords();

    this._widgets = [item, ...this._widgets];

    this.widgetsChanged.emit({item, action: EM_ACTION.CREATE}); //this.widgetsChanged.emit(this._widgets);

    this.cdref.markForCheck();
  }

  checkDragOver(event: WizDropItemEvent): boolean {
    
    let result: boolean = false;
    this.gridster.emptyCell.emptyCellDragOver(event.event);

    let exist: GridsterWidgetItem;
    let dropEffect: string;

    if (!event.item.data.arg || event.item.data.arg.dataType === FIELD_KIND.OBJECT) { // plusieurs fois possibles pour un champ Objet et les libellés
      result = true;
    } else {
      exist = this._widgets.find(wo => (wo.field as PivotField).code === event.item.data.code);
      dropEffect = event.event.dataTransfer.dropEffect;
      if (!exist && dropEffect !== 'none') {
        result = true;
      }
    }
    return result;
  }

}
